var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgShoppingCart(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 46,
    height: 46,
    viewBox: "0 0 46 46",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.25 4.25H7.51251C9.53751 4.25 11.1313 5.99375 10.9625 8L9.40625 26.675C9.14375 29.7312 11.5625 32.3562 14.6375 32.3562H34.6063C37.3063 32.3562 39.6687 30.1438 39.875 27.4625L40.8875 13.4C41.1125 10.2875 38.75 7.75624 35.6187 7.75624H11.4125",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M30.9688 41.75C32.2632 41.75 33.3125 40.7007 33.3125 39.4062C33.3125 38.1118 32.2632 37.0625 30.9688 37.0625C29.6743 37.0625 28.625 38.1118 28.625 39.4062C28.625 40.7007 29.6743 41.75 30.9688 41.75Z",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15.9688 41.75C17.2632 41.75 18.3125 40.7007 18.3125 39.4062C18.3125 38.1118 17.2632 37.0625 15.9688 37.0625C14.6743 37.0625 13.625 38.1118 13.625 39.4062C13.625 40.7007 14.6743 41.75 15.9688 41.75Z",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M17.375 15.5H39.875",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShoppingCart);
export default __webpack_public_path__ + "static/media/shopping-cart.331fc23f15d1e4cc8e17f16bf93583a7.svg";
export { ForwardRef as ReactComponent };